module.exports = __webpack_public_path__ + "img/sce_p5_img_6.4f10276e.png";